import { render, staticRenderFns } from "./BizgainMessageComponent.vue?vue&type=template&id=24590b7b&"
import script from "./BizgainMessageComponent.vue?vue&type=script&lang=js&"
export * from "./BizgainMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports